import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { KeyRound, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("Minimum 8 characters");
    if (pw !== pw2) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — sign in with your new password");
      nav("/admin/login");
    } catch (e) { toast.error(e?.response?.data?.detail || "Reset failed"); }
    finally { setLoading(false); }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#090D14] grid place-items-center text-white p-4">
        <div className="glass-card rounded-2xl p-8 gold-border max-w-md w-full text-center">
          <h1 className="font-display text-xl font-bold">Invalid reset link</h1>
          <p className="text-sm text-slate-400 mt-2">This link is missing a token. Request a fresh one.</p>
          <Link to="/admin/forgot-password"><Button className="btn-gold rounded-lg mt-6">Request new link</Button></Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#090D14] grid place-items-center text-white p-4">
      <div className="w-full max-w-md">
        <div className="glass-card rounded-2xl p-8 gold-border">
          <div className="text-caption mb-2 flex items-center gap-1.5"><KeyRound className="w-3.5 h-3.5" /> New password</div>
          <h1 className="font-display text-2xl font-bold">Set a new password</h1>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="text-xs uppercase text-slate-400 tracking-wider">New password</Label>
              <Input data-testid="reset-pw" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} className="bg-black/30 border-white/10 h-11 mt-2" />
            </div>
            <div>
              <Label className="text-xs uppercase text-slate-400 tracking-wider">Confirm</Label>
              <Input data-testid="reset-pw2" type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} className="bg-black/30 border-white/10 h-11 mt-2" />
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full btn-gold rounded-lg h-11">
              {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Update password
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
